import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBathMan1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBathMan1"><Path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><Path d="M7.75 8C6.7835 8 6 8.7835 6 9.75V15.25C6 16.2165 6.7835 17 7.75 17H8V21.75C8 22.4404 8.55964 23 9.25 23H14.75C15.4404 23 16 22.4404 16 21.75V17H16.25C17.2165 17 18 16.2165 18 15.25V9.75C18 8.7835 17.2165 8 16.25 8H7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBathMan1;
